import styled from 'styled-components';

export const Container = styled.div`
  background: 0% 0% no-repeat padding-box padding-box rgb(0, 15, 255);
  opacity: 1;
  display: flex;
  flex-direction: column;
`;

export const DegradeDesktop = styled.div`
  z-index: 1;
  position: fixed;
  width: 700px;
  height: 100vh;
  top: 8%;
  margin-left: 0;
  transform: rotate(-90deg);
  background: linear-gradient(
      180deg,
      rgb(0, 255, 0) 0%,
      rgb(0, 255, 246) 80%,
      rgb(0, 255, 255) 100%
    )
    center top no-repeat padding-box padding-box transparent;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;

  @media (max-width: 1460px) {
    top: 0%;
    width: 500px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TextContainer = styled.div`
  transform: rotate(90deg);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  text-align: left;
`;

export const WelcomeText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 37.11px;
  font-weight: 400;
  line-height: 41.53px;
  @media (max-width: 1460px) {
    font-size: 30px;
  }
`;

export const PortalText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 47.55px;
  font-weight: 700;
  line-height: 53.21px;
  @media (max-width: 1460px) {
    font-size: 32px;
  }
`;
export const DegradeMobile = styled.div`
  z-index: 2;
  position: absolute;
  width: 100vw;
  bottom: -15%;
  background: url(/static/ondas.6cce42b5.png) no-repeat;
  display: none;
  flex-direction: column;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const Content = styled.div`
  z-index: 2;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;

  @media (max-width: 768px) {
    overflow: auto;
  }
`;

export const ContentLogo = styled.div`
  width: 25%;
  height: 100vh;

  @media (max-width: 768px) {
    display: none;
    height: 100%;
  }
`;

export const Logo = styled.img`
  padding-top: 45px;
  padding-left: 10%;
  width: 80%;
  height: auto;
`;

export const ContentImages = styled.div`
  width: 40%;
  height: 100vh;

  @media (max-width: 768px) {
    display: none;
  }
`;

type ImageProps = {
  isActive: boolean;
};

export const Image = styled.img<ImageProps>`
  position: fixed;
  left: 23%;
  bottom: 0px;
  width: 40%;
  height: auto;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transition: opacity 2s ease 0s;
`;

export const ContentLogin = styled.div`
  width: 38%;
  height: 100vh;
  position: fixed;
  top: 10%;
  left: 58%;

  @media (max-width: 1460px) {
    top: 6%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    position: inherit;
  }
`;

export const ContentAlign = styled.div`
  width: 70%;
  height: fit-content;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-left: 2%;
    margin-right: 2%;
  }
`;

export const ContentAlignLogo = styled.div`
  width: 100%;
  padding: 10px 0px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FirstPart = styled.p`
  font-family: Mangueira;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 17.9px;
  letter-spacing: 0%;
  padding-right: 10px;
`;

export const SecondPart = styled.p`
  font-family: Mangueira;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  line-height: 17.9px;
  letter-spacing: 0%;
`;

export const ContentAlignLogin = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  min-height: 33%;
  padding: 25px;
  background-color: rgb(255, 255, 255);
  border-radius: 21px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 3px 6px;

  @media (max-width: 1460px) {
    padding: 20px;
  }

  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
`;
